import { render, staticRenderFns } from "./CollectorLogLevelsSubPanel.vue?vue&type=template&id=12dce1a1&scoped=true"
import script from "./CollectorLogLevelsSubPanel.vue?vue&type=script&lang=js"
export * from "./CollectorLogLevelsSubPanel.vue?vue&type=script&lang=js"
import style0 from "./CollectorLogLevelsSubPanel.vue?vue&type=style&index=0&id=12dce1a1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dce1a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/8268df4d62037a26/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12dce1a1')) {
      api.createRecord('12dce1a1', component.options)
    } else {
      api.reload('12dce1a1', component.options)
    }
    module.hot.accept("./CollectorLogLevelsSubPanel.vue?vue&type=template&id=12dce1a1&scoped=true", function () {
      api.rerender('12dce1a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Logs/CollectorLogLevelsSubPanel.vue"
export default component.exports